import request from '@/apis/axios'
import type { IResponse } from '@/apis/axios/config'
import type {
  checkVerifyCodeParam,
  checkVerifyCodeResult,
  sendVerifyCodeParam,
  sendVerifyCodeResult,
  signupCompleteParam,
  signupCompleteResult,
  SignupStepInfoResult,
} from '~/apis/signup/type'

/**
 * 2.3.1 회원가입에 필요한 목적(회원유형), 이용약관, 개인정보수집동의 조회
 */
export const signupStepInfo = (): Promise<IResponse<SignupStepInfoResult>> => {
  return request.get({ url: '/jadooApiV1/userJoinInfo' })
}

/**
 * 2.3.3 회원가입 문자 발송 처리
 */
export const sendVerifyCode = (
  data: sendVerifyCodeParam,
): Promise<IResponse<sendVerifyCodeResult>> => {
  return request.post({ url: '/jadooApiV1/userJoinSms', data })
}
/**
 * 2.3.3 회원가입 문자 인증
 */
export const checkVerifyCode = (
  params: checkVerifyCodeParam,
): Promise<IResponse<checkVerifyCodeResult>> => {
  return request.get({ url: '/jadooApiV1/userJoinSms', params })
}

/**
 * 2.3.4 회원 가입 처리
 * (소셜 계정 추가도 포함, 회원가입과 동일하게)
 */
export const signupComplete = (
  data: signupCompleteParam,
): Promise<IResponse<signupCompleteResult>> => {
  return request.put({ url: '/jadooApiV1/userInfo', data })
}
